<template>
    <div class="page__inner page__bg page__bg-02 text-center ">
        <div class="content container-fluid px-0 ">
            <div class="row no-gutters ">
                <div class="col-12">
                    <Timeline :key="timelineKey"></Timeline>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import lrsService from "@/services/lrsService";
    import { Hooper, Slide, Pagination as HooperPagination } from 'hooper';
    import Timeline from "@/components/Timeline";
    export default {
        name: "page-020",
        components:{
            Timeline
        },
        props:{
            kapitel: ""
        },
        data: function () {
            return {
                video01state: false,
                video02state: false,
                windowWidth: 0,
                windowHeight: 0,
                sliderIndex: 0,
                overlayIndex: 1,
                overlayOpen: false,
                overlaySlideIndex1:0,
                overlaySlideIndex2:0,
                overlaySlideIndex3:0,
                overlaySlideIndex4:0,
                timelineKey: 0,
            }
        },
        methods: {
            openOverlay(){
                this.overlaySlideIndex1 = 0;
                this.overlaySlideIndex2 = 0;
                this.overlaySlideIndex3 = 0;
                this.overlaySlideIndex4 = 0;
                this.overlayOpen = true;
            },
            closeOverlay(){
                this.overlayOpen = false;
            },
            toggleVideoState(selector, state){
                if(state == true){
                    // Play Video
                    let wrapper = document.querySelector(selector).classList.remove("not-played");
                    let video = document.querySelector(selector + " video");
                    console.log(video);
                    video.play();
                    this.video01state = !this.video01state;
                } else {
                    //Pause Video
                    let video = document.querySelector(selector + " video");
                    video.pause();
                    this.video01state = !this.video01state;
                }
            },
            getWindowWidth(event) {
                this.windowWidth = document.documentElement.clientWidth;
            },
            getWindowHeight(event) {
                this.windowHeight = document.documentElement.clientHeight;
            },
            openDetailPage(){
                //TODO: Open Detail Page
                window.open('/makeup-studio_uk_en/complexion/synchro-skin-self-refreshing-custom-finish-powder-foundation/?module=MakeUp&chapter=&mpage=&lang=uk_en',"_self")
            },
            isMobile(){
                if(this.windowWidth <= 768){
                    return true
                } else {
                    return false
                }
            }
        },
        mounted(){
          let k = Math.random() * 1000;
          this.timelineKey = k;
            this.$nextTick(function() {
                window.addEventListener('resize', this.getWindowWidth);
                window.addEventListener('resize', this.getWindowHeight);

                //Init
                this.getWindowWidth()
                this.getWindowHeight()
            })
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.getWindowWidth);
            window.removeEventListener('resize', this.getWindowHeight);
        }
    }
</script>

<style scoped>

</style>